import { ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/Button'

type FinalCTAProps = {
	onGetStarted: () => void
}

export function FinalCTA({ onGetStarted }: FinalCTAProps) {
	return (
		<section className="landing-final-cta-section">
			<div className="landing-final-cta-container">
				<h2 className="landing-final-cta-title">
					Ready to modernize your playbook?
				</h2>
				<p className="landing-final-cta-subtitle">
					We're launching soon. Get on the list.
				</p>
				<Button
					variant="action"
					size="lg"
					onClick={onGetStarted}
					className="landing-final-cta-button"
				>
					Join the Waitlist
					<ChevronRight className="landing-hero-cta-icon" />
				</Button>
				<p className="landing-final-cta-note">
					Be first in line when we launch
				</p>
			</div>
		</section>
	)
}
